import React from "react";
import DefaultCard from "./default-card";
import {loginUrl} from '../constants';

const AccountCard = ({ category, isGuest }) => (
  <DefaultCard
    category={{
      ...category,
      link: {
        ...category.link,
        href: isGuest
          ? loginUrl
          : category.link.href,
        defaultUrl:`/help/accounts`,
      },
    }}
    shrinkable={true}
  />
);

export default AccountCard;
